/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{margin-top:30px;padding-top:15px;border-top:1px solid #f2eeee;color:#c3c3c3}.col[_ngcontent-%COMP%]{margin-right:15px}"];
export { styles as styles };
